function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserMaleTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user_x5F_male_x5F_target",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "user_x5F_male_x5F_target_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M24,14c-3.309,0-6-2.692-6-6s2.691-6,6-6s6,2.692,6,6S27.309,14,24,14z M24,4c-2.206,0-4,1.794-4,4 s1.794,4,4,4s4-1.794,4-4S26.206,4,24,4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 10,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 7,
    style: {
      fill: "#FD5C3F"
    },
    width: 6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 7,
    style: {
      fill: "#FD5C3F"
    },
    width: 6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M26,32H0v-1c0-2.689,2.822-3.855,5.312-4.884C6.947,25.441,8.8,24.676,8.8,23.8 c0-0.394-0.247-0.8-0.683-1.482c-0.472-0.739-1.092-1.708-1.5-3.118H6.6c-1.438,0-2.094-1.813-2.094-3.497 c0-1.451,0.484-2.29,1.09-2.695C5.8,9.109,9.043,6,13,6v2c-2.986,0-5.415,2.422-5.415,5.4L7.64,14.7H6.683 c-0.291,0.423-0.208,1.985,0.121,2.5h1.413L8.38,18c0.305,1.491,0.898,2.421,1.423,3.241c0.513,0.803,0.997,1.561,0.997,2.559 c0,2.213-2.401,3.205-4.724,4.165C4.616,28.568,3.12,29.186,2.415,30h21.17c-0.705-0.814-2.201-1.432-3.661-2.035 C17.602,27.005,15.2,26.013,15.2,23.8c0-0.998,0.484-1.756,0.997-2.559c0.524-0.82,1.118-1.75,1.423-3.241l0.163-0.8h1.404 c0.11-0.197,0.262-0.647,0.298-1.258l1.996,0.116c-0.11,1.909-0.928,3.142-2.081,3.142h-0.018c-0.408,1.41-1.028,2.38-1.5,3.118 C17.447,23,17.2,23.406,17.2,23.8c0,0.875,1.853,1.641,3.487,2.316C23.178,27.145,26,28.311,26,31V32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6,
    style: {
      fill: "#FD5C3F"
    },
    width: 1,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMaleTarget);
export default __webpack_public_path__ + "static/media/user_male_target.73193f19192d96666a4d4f70d5820d94.svg";
export { ForwardRef as ReactComponent };